import {
  ButtomSubmitted,
  ContactForm,
  ContainerContact,
  ContactInformation,
  ContainerStyled,
  Input,
  TextArea,
} from "./styles";
import logo from "../../assets/logo.png";
import { useState } from "react";
import useAuth from "../../hooks/useAuth";
import { sendEmail } from "../../services/resources/EmailContact";
import { sendResponseEmail } from "../../services/resources/EmailResponse";

export const Contact = () => {
  const { user } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSendEmail = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const data = {
      email,
      message,
    };

    if (message === "") {
      setErrorMessage("Mensagem Inválida");
      return;
    }
    await sendEmail(data);

    setErrorMessage("");
    setMessage("Email Enviado!");

    const dataReponse = {
      email,
    };

    await sendResponseEmail(dataReponse);
  };

  return (
    <ContainerStyled id="contact">
      <ContainerContact>
        <ContactInformation>
          <img src={logo} alt="" />
          <h2>
            Serviços Personalizados de Desenvolvimento de Software e Tecnologia
          </h2>
          <p>Rio de Janeiro - RJ</p>
          <p>Tel: +55 21 96640-5629</p>
          <p>E-mail: luizarthur.fortunato@gmail.com</p>
        </ContactInformation>
        <ContactForm onSubmit={handleSendEmail}>
          <h2>Contato</h2>
          <Input
            type="text"
            placeholder="Nome"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
          <Input
            type="email"
            placeholder="E-mail"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          <TextArea
            name="message"
            placeholder="Mensagem"
            required
            value={message}
            onChange={(event) => setMessage(event.target.value)}
          />
          {errorMessage && <p>{errorMessage}</p>}

          <div>
            <div>
              <ButtomSubmitted type="submit">ENVIAR MENSAGEM</ButtomSubmitted>
            </div>
          </div>
        </ContactForm>
      </ContainerContact>
    </ContainerStyled>
  );
};
